export const portfolioData = {
  personal: {
    name: "Vamsi",
    title: "Full Stack Developer",
    image: "https://res.cloudinary.com/kits/image/upload/v1780117947/image_mine_bftbsj.jpg",
    email: "padalavamsi@zohomail.in",
    social: {
      linkedin: "https://www.linkedin.com/in/padalavamsi/",
      github: "https://github.com/VamsiPadala",
      instagram: "https://www.instagram.com/vamsi_rockingstar/?__pwa=1",
      whatsapp: "https://wa.me/916304497226"
    }
  },
  about: {
    description: "I'm studying Tech at Acharya Nagarjuna University. I'm a passionate Full Stack Developer skilled in creating web apps with clean UI and powerful backend."
  },
  skills: {
    frontend: [
      { name: "HTML", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
      { name: "CSS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
      { name: "JavaScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
      { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { name: "Bootstrap", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" }
    ],
    backend: [
      { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
      { name: "Express.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" },
      { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" }
    ],
    database: [
      { name: "MongoDB", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
      { name: "SQLite", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg" },
      { name: "MySQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" }
    ]
  },
  experience: [
    {
      role: "Associate Developer",
      company: "Mindwhile IT Solutions",
      type: "Full-Time",
      duration: "Feb 2026 - Present",
      description: "Working as an Associate Developer contributing to enterprise web applications and system solutions.",
      responsibilities: [
        "Developing and maintaining scalable web applications",
        "Collaborating with cross-functional teams to deliver software solutions",
        "Optimizing application performance and user experience"
      ],
      technologies: ["React", "Node.js", "JavaScript", "SQL"]
    },
    {
      role: "Full Stack Developer",
      company: "AB DIGITALS",
      type: "Part-Time",
      duration: "Jan 2024 - Present",
      description: "Developed and maintained web applications using modern technologies.",
      responsibilities: [
        "Built responsive web applications using React and Node.js",
        "Implemented RESTful APIs and database integration",
        "Collaborated with design team for UI/UX improvements"
      ],
      technologies: ["React", "Node.js", "MongoDB", "Express.js"]
    },
    {
      role: "Freelance Application Developer",
      company: "Self-Employed",
      type: "Freelance",
      duration: "Jun 2023 - Present",
      description: "Developed and actively maintain multiple public-facing production applications.",
      responsibilities: [
        "Architected and deployed enterprise solutions like School ERP and Books Management systems",
        "Developed Jago App, a real-time bike taxi platform handling live tracking and bookings",
        "Built and currently maintain consultancy platforms for SR Education and Akshaya Educ",
        "Ensuring high availability, performing regular updates, and managing public user scale"
      ],
      technologies: ["React", "React Native", "Node.js", "MongoDB", "Express.js", "WebSockets"]
    }
  ],
  projects: [
    {
      title: "School ERP System",
      description: "A comprehensive Enterprise Resource Planning system built specifically for school administration, student management, and academic tracking.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1780123593/Screenshot_2026-05-30_121601_by18d5.png"
    },
    {
      title: "Jago App (Bike Taxi)",
      description: "A real-time ride-hailing application similar to Rapido, featuring live driver tracking, instant booking, and secure payment processing.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1780123624/jago_screen2_mlqhyx.png"
    },
    {
      title: "Books Management App",
      description: "A digital library and inventory management system for tracking book collections, issuing books, and managing user records seamlessly.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1780123772/Screenshot_2026-05-30_121920_thboid.png"
    },
    {
      title: "SR Education App",
      description: "A specialized consultancy application designed for SR Education to manage student admissions, counseling sessions, and visa processing.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1780123656/Screenshot_2026-05-30_121727_yzz8w6.png"
    },
    {
      title: "Akshaya Educ Platform",
      description: "An educational consultancy platform built for Akshaya Educ to streamline student enrollments and provide real-time updates.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1780123682/Screenshot_2026-05-30_121751_sv2zrj.png"
    },
    {
      title: "Woodworks Online Booking",
      description: "A comprehensive booking platform for woodwork services with real-time availability.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1760291833/Gemini_Generated_Image_zaiqquzaiqquzaiq_ygx9ve.png"
    },
    {
      title: "Clothing E-commerce",
      description: "Full-featured e-commerce platform with payment integration and inventory management.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1760291838/Gemini_Generated_Image_l801uul801uul801_nqujlx.png"
    },
    {
      title: "Deepfake Recognition",
      description: "AI-powered system to detect and analyze deepfake content in images and videos.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1760291832/Gemini_Generated_Image_nnimnonnimnonnim_m7spue.png"
    },
    {
      title: "Farm Product Booking",
      description: "Platform connecting farmers with consumers for fresh produce delivery.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1760291832/Gemini_Generated_Image_q0ka62q0ka62q0ka_kmyghr.png"
    },
    {
      title: "College Complaint Management",
      description: "Streamlined system for managing and resolving college-related complaints.",
      thumbnail: "https://res.cloudinary.com/kits/image/upload/v1760291832/Gemini_Generated_Image_42l41442l41442l4_p83ema.png"
    }
  ],
  certificates: [
    {
      id: 1,
      title: "SQL Intermediate",
      issuer: "HackerRank",
      image: "https://res.cloudinary.com/kits/image/upload/v1760341075/Screenshot_2025-10-13_130331_wtuz1e.png",
      link: "https://www.hackerrank.com/certificates/ae60ece3e788"
    },
    {
      id: 2,
      title: "IoT",
      issuer: "Coursera",
      image: "https://res.cloudinary.com/kits/image/upload/v1760341075/iot_iwqmfr.png",
      link: "https://www.coursera.org/account/accomplishments/verify/2D4T1JGE000T"
    },
    {
      id: 3,
      title: "Job Simulation",
      issuer: "AWS Forage",
      image: "https://res.cloudinary.com/kits/image/upload/v1760341074/aws_vtzzql.png"
    },
    {
      id: 4,
      title: "Python (Basic)",
      issuer: "HackerRank",
      image: "https://res.cloudinary.com/kits/image/upload/v1760341075/python_basic_ruuyfb.png",
      link: "https://www.hackerrank.com/certificates/3bac12a06718"
    },
    {
      id: 5,
      title: "CSS (Basic)",
      issuer: "HackerRank",
      image: "https://res.cloudinary.com/kits/image/upload/v1760341075/css_basic_r9hdyk.png",
      link: "https://www.hackerrank.com/certificates/c8edae990e44"
    },
    {
      id: 6,
      title: "SQL (Basic)",
      issuer: "HackerRank",
      image: "https://res.cloudinary.com/kits/image/upload/v1760341363/sql_basic_p5wnb4.png",
      link: "https://www.hackerrank.com/certificates/635d663dd141"
    }
  ],
  achievements: [
    {
      title: "Launched Karthik Wood Works",
      description: "Booking & representation site for woodwork services",
      link: "https://www.linkedin.com/posts/padalavamsi_webdevelopment-freelancedeveloper-reactjs-activity-7380007265992581120-PHjg?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEc9t2YBSoKhShMcRK7kVzMuUQ1AjUhQ47E"
    },
    {
      title: "Launched Suddhi Farms",
      description: "Farm product selling site",
      link: "https://www.linkedin.com/posts/padalavamsi_webdevelopment-freelancedeveloper-mernstack-activity-7383488626615177216-7C-6?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEc9t2YBSoKhShMcRK7kVzMuUQ1AjUhQ47E"
    }
  ]
};